<template>
    <section style="margin:18px;"> 
        <v-btn @click="OpenAddClassroom">Add Classroom Schedule</v-btn>
        <v-btn @click="OpenAddWebinar">Add Online Schedule</v-btn>
        <app-add-schedule ref="Schedule" :dialog='AddScheduleDialog' @close='CloseDialog'></app-add-schedule>
        <app-schedule-table></app-schedule-table>
    </section>
</template>
<script>
import appAddSchedule  from '../views/dialogs/AddSchedule'
import appScheduleTable from '../views/tables/SchedulesTable'
export default {
    components:{
        appAddSchedule,
        appScheduleTable
    },
    data(){
        return{

            AddScheduleDialog   : false

        }
    },
    methods:{
        OpenAddClassroom(){

            this.$refs.Schedule.SetScheduleType('Classroom')
            this.AddScheduleDialog = true
        },
        OpenAddWebinar(){

            this.$refs.Schedule.SetScheduleType('Webinar')
            this.AddScheduleDialog = true
        },
        CloseDialog(){

            this.AddScheduleDialog = false
        }
    },
    mounted(){
        this.$eventHub.$emit("LOADING",'false')
    }
}
</script>
<style scoped>

</style>
